import React from 'react';
import cn from 'classnames';
import findIndex from 'lodash/findIndex';

import RsSlidable from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidable';
import { LEYDEN_TAB_GROUP_CLASSES } from '@Containers/ResultToolbar/DatabaseSwitcher/LeydenClasses';
import { RouteType } from '@Pages/RetroSynthesis/constants';

import './StepsList.scss';

function StepsList({ steps, activeStep, setActiveStep, resized, onActiveStepChange, routeType }) {
  const activeStepIndex = findIndex(steps, { step: activeStep });
  const stepsHaveDifferentTypes = steps.some((s) => s.type !== steps?.[0]?.type);

  return (
    <RsSlidable
      className="project-route-conditions-steps-list rx-flex-1"
      containerClassName={LEYDEN_TAB_GROUP_CLASSES.tabGroup}
      contentClassName="project-route-conditions-steps-list__list"
      itemClassName={({ step }) => cn('project-route-conditions-steps-list__step', { current: step === activeStep })}
      items={steps}
      renderItem={({ step, type }, i) => (
        <span
          className={cn(LEYDEN_TAB_GROUP_CLASSES.tabGroupItem, LEYDEN_TAB_GROUP_CLASSES.tabGroupText, {
            [LEYDEN_TAB_GROUP_CLASSES.tabGroupItemActive]: activeStepIndex === i,
          })}
          role="button"
          style={{ cursor: 'pointer' }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onActiveStepChange(step);
              setActiveStep(step);
            }
          }}
          onClick={() => {
            onActiveStepChange(step);
            setActiveStep(step);
          }}>
          {routeType === RouteType.COMBINED || stepsHaveDifferentTypes ? (
            <>
              {type === RouteType.PUBLISHED && (
                <>
                  <span>Pub. step {step}</span>
                  <span className="project-route-conditions-steps-list__type project-route-conditions-steps-list__type--published" />
                </>
              )}
              {type === RouteType.PREDICTED && (
                <>
                  <span>Pred. step {step}</span>
                  <span className="project-route-conditions-steps-list__type project-route-conditions-steps-list__type--predicted" />
                </>
              )}
            </>
          ) : (
            `Step ${step}`
          )}
        </span>
      )}
      visibleItemIndex={activeStepIndex}
      resized={resized}
    />
  );
}

export default StepsList;
